import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { NbButtonModule, NbCardModule, NbSpinnerModule } from '@nebular/theme';
import {
  DashboardFrequenciaSemana,
  FaltaSemanaAnterior,
  TurmaSemChamadaSemana,
} from '../../../core/api/dashboard-frequencia-semana';
import { DashboardService } from '../../../core/api/dashboard.service';
import { mensagemDeErro } from '../../../utils/mensagem-erro';

@Component({
  selector: 'app-dashboard-frequencia-semana',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink,
    NbCardModule,
    NbButtonModule,
    NbSpinnerModule,
  ],
  templateUrl: './dashboard-frequencia-semana.component.html',
  styleUrl: './dashboard-frequencia-semana.component.scss',
})
export class DashboardFrequenciaSemanaComponent implements OnInit {
  dados: DashboardFrequenciaSemana | null = null;
  carregando = true;
  erro: string | null = null;

  /** '' = todas as turmas */
  filtroTurmaId: string | null = null;

  constructor(private dashboardService: DashboardService) {}

  ngOnInit(): void {
    this.carregar();
  }

  carregar(): void {
    this.carregando = true;
    this.erro = null;
    this.dashboardService.frequenciaSemanaAnterior().subscribe({
      next: (d) => {
        this.dados = d;
        this.carregando = false;
        this.filtroTurmaId = null;
      },
      error: (err) => {
        this.carregando = false;
        this.dados = null;
        this.erro = mensagemDeErro(err, 'Não foi possível carregar o relatório.');
      },
    });
  }

  get periodoTexto(): string {
    const i = this.dados?.semanaAnteriorInicio;
    const f = this.dados?.semanaAnteriorFim;
    if (!i || !f) return '';
    return `${this.br(i)} a ${this.br(f)}`;
  }

  private br(iso: string): string {
    const p = iso.split('-');
    if (p.length !== 3) return iso;
    return `${p[2]}/${p[1]}/${p[0]}`;
  }

  get turmasParaFiltro(): { id: string; nome: string }[] {
    const faltas = this.dados?.faltasNaSemana ?? [];
    const mapa = new Map<string, string>();
    for (const f of faltas) {
      const id = f.turmaId?.trim();
      if (id) mapa.set(id, f.turmaNome ?? id);
    }
    return [...mapa.entries()]
      .map(([id, nome]) => ({ id, nome }))
      .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR', { sensitivity: 'base' }));
  }

  get faltasFiltradas(): FaltaSemanaAnterior[] {
    const lista = this.dados?.faltasNaSemana ?? [];
    const tid = this.filtroTurmaId?.trim();
    if (!tid) return lista;
    return lista.filter((f) => (f.turmaId ?? '').trim() === tid);
  }

  trackByTurma = (_: number, t: TurmaSemChamadaSemana): string => t.turmaId ?? '';
  trackByFalta = (_: number, f: FaltaSemanaAnterior): string => `${f.turmaId}-${f.pessoaId}`;
}
